import { combineEpics, ofType, } from 'redux-observable';
import {
  filter, flatMap, ignoreElements, pluck, switchMap, take, tap,
} from 'rxjs/operators';
import { actions as bootstrapActions, socket$, } from '@ezugi/bootstrap';
import {
  CANCEL_LAST_CARD,
  CANCEL_ROUND,
  CARD,
  GAME_RESULT,
  INITIAL_DATA,
  NO_MORE_BETS,
  PLACE_YOUR_BETS,
  WON_BETS,
} from '@ezugi/constants';
import { Card, } from '@ezugi/primitives';

import handleInitialData from './handleInitialData';
import handleGameResult from './handleGameResult';
import handleCardMessage from './handleCardMessage';
import handleCancelLastCard from './handleCancelLastCard';
import handleWonBets from './handleWonBets';
import handlePlaceYourBets from './handlePlaceYourBets';
import handleCancelRound from './handleCancelRound';
import handleNoMoreBets from './handleNoMoreBets';

/* BACK & LAY */
import handleBLWonBets from '../BackAndLay/socket/handleBLWonBets';

import { isBackAndLaySelector, } from '../../selectors/game';

const { socketActions: { socket, }, videoActions: { video, }, } = bootstrapActions;

function initialDataEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === INITIAL_DATA),
    flatMap((socketMessage) => handleInitialData(socketMessage, state$.value))
  );
}

function placeYourBetsEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === PLACE_YOUR_BETS),
    flatMap((socketMessage) => handlePlaceYourBets(socketMessage, state$.value))
  );
}

function noMoreBetsEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === NO_MORE_BETS),
    flatMap((socketMessage) => handleNoMoreBets(socketMessage, state$.value))
  );
}

function gameResultEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === GAME_RESULT),
    flatMap((socketMessage) => handleGameResult(socketMessage, state$.value))
  );
}

function cardMessageEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === CARD),
    flatMap((socketMessage) => handleCardMessage(socketMessage, state$.value))
  );
}

function cancelLastCardEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === CANCEL_LAST_CARD),
    flatMap((socketMessage) => handleCancelLastCard(socketMessage, state$.value))
  );
}

function cancelRoundEpic(action$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === CANCEL_ROUND),
    flatMap(handleCancelRound)
  );
}

function preloadCardEpic(action$, state$) {
  return action$.pipe(
    ofType(video.set),
    take(1),
    pluck('payload', 'cdnList', 'videoDelay'),
    switchMap(
      (delay) => (+delay
        ? socket$.pipe(
          filter(({ MessageType, }) => MessageType === CARD),
          pluck('CardName'),
          tap((name) => Card.preload({
            name,
            type: isBackAndLaySelector(state$.value) ? Card.CARD_TYPES.SMALL : Card.CARD_TYPES.REGULAR,
          }))
        )
        : socket$.pipe(
          take(1),
          tap(() => {
            Card.preloadAll(isBackAndLaySelector(state$.value) ? Card.CARD_TYPES.SMALL : Card.CARD_TYPES.REGULAR);
          })
        ))
    ),
    ignoreElements()
  );
}

function wonBetsEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === WON_BETS),
    flatMap((socketMessage) => (isBackAndLaySelector(state$.value)
      ? handleBLWonBets(socketMessage, state$.value) : handleWonBets(socketMessage, state$.value)
    ))
  );
}

export default combineEpics(
  gameResultEpic,
  cardMessageEpic,
  preloadCardEpic,
  cancelLastCardEpic,
  cancelRoundEpic,
  initialDataEpic,
  wonBetsEpic,
  placeYourBetsEpic,
  noMoreBetsEpic,
);
